module.exports = __webpack_public_path__ + "resources/img/img_dataquery_m_en.4a2a1f19d0e4430dc4401de3ee6898e8.png";